import React from "react";

export const SlideshowIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0"
    y="0"
    enableBackground="new 0 0 470.204 470.204"
    version="1.1"
    viewBox="0 0 470.204 470.204"
    xmlSpace="preserve"
  >
    <path
      fill="#1185E0"
      d="M350.041 357.355H120.163c-8.882 0-15.673-6.792-15.673-15.673v-213.16c0-8.882 6.792-15.673 15.673-15.673h229.878c8.882 0 15.673 6.792 15.673 15.673v213.159c0 8.882-6.792 15.674-15.673 15.674zm-214.204-31.347h198.531V144.196H135.837v181.812z"
    />
    <g fill="#4DCFE0">
      <path d="M67.918 331.233c-8.882 0-15.673-6.792-15.673-15.673V154.645c0-8.882 6.792-15.673 15.673-15.673s15.673 6.792 15.673 15.673v160.914c.001 8.882-6.791 15.674-15.673 15.674zM15.673 305.11C6.792 305.11 0 298.318 0 289.437v-108.67c0-8.882 6.792-15.673 15.673-15.673s15.673 6.792 15.673 15.673v108.669c.001 8.882-6.791 15.674-15.673 15.674zM402.286 331.233c-8.882 0-15.673-6.792-15.673-15.673V154.645c0-8.882 6.792-15.673 15.673-15.673s15.673 6.792 15.673 15.673v160.914c0 8.882-6.792 15.674-15.673 15.674zM454.531 305.11c-8.882 0-15.673-6.792-15.673-15.673v-108.67c0-8.882 6.792-15.673 15.673-15.673s15.673 6.792 15.673 15.673v108.669c0 8.882-6.792 15.674-15.673 15.674z" />
    </g>
  </svg>
);
